import React, { useRef } from 'react'
import ADND from '@aytm/lib/adnd/ADND'

export const DragBar: React.FC<{
  index: number
  uid: string
  className: string
  onDrag: (payload: { action: string; index: number; uid?: string }) => void
}> = ({ index, uid, onDrag, className }) => {
  const dragSource = useRef<{ connect: (node: HTMLElement | null) => void }>(null)

  const onDragRef = useRef<((payload: { action: string; index: number; uid?: string }) => void) | undefined>(null)
  onDragRef.current = onDrag

  if (null == dragSource.current) {
    dragSource.current = ADND.sources
      .draggableData({
        type: 'concept',
        parent: 2,
        lockY: true,
        dragLayerClassName: `PRAYTMTheme ${className}-source`
      })
      .fetchData(() => {
        return { index, uid }
      })
      .onStart(() => {
        onDragRef?.current({ action: 'start', index, uid })
      })
      .onEnd(() => {
        onDragRef?.current({ action: 'end', index, uid })
      })
  }

  return (
    <div className={className} ref={node => void dragSource.current.connect(node)}>
      <i className={`icon-aytmfd-sandwich ${className}-icon`} />
    </div>
  )
}
